export const environment = {
  production: false,
  site_key: '6LdFEe0dAAAAAN-baA5__-7z1vHRhxgynNhHrPnC',
  backendUrl: 'https://backend.affiliate.webiz.com',
};